export default __webpack_public_path__ + "static/media/download.b835d50c.svg";